import dayjs from "dayjs";
const filters = [
  {
    name: "getShortFormattedWaitTime",
    execute: (minutes) => {
      let hours = Math.floor(minutes / 60);
      let mins = minutes % 60;
      return hours + "h " + mins + "m";
    },
  },
  {
    name: "getShortFormattedWaitTimeFromSeconds",
    execute: (seconds) => {
      let hours = Math.floor(seconds / 3600);
      seconds %= 3600;
      let mins = Math.floor(seconds / 60);
      return hours + "h " + mins + "m";
    },
  },
  // wait time got changed to minutes
  // {
  //   name: "minimumSixtySeconds",
  //   execute: (value) => {
  //     // always show at least 1 minute
  //     if (value < 60) value = 60;
  //     return value;
  //   },
  // },
  {
    name: "getTimeOnly",
    execute: (value) => {
      if (value) {
        return dayjs(String(value)).format("hh:mm A");
      }
    },
  },
  {
    name: "getDateOnly",
    execute: (value) => {
      if (value) {
        return dayjs(String(value)).format("DD/MM/YYYY");
      }
    },
  },
];

export default filters;
